import { ButtonVariant } from 'src/components/atoms/Button';
import Tile from 'src/components/DUP/atoms/Tile/Tile';
import ConnectedAccountsList from 'src/components/DUP/molecules/ConnectedAccountsList/ConnectedAccountsList';
import { useApplication } from 'src/context/ApplicationContext';
import { useStepTranslations } from 'src/hooks/useClientTranslations';
import {
  generateButtonIdForTiles,
  generateTileDataAttributes,
  StepType
} from 'src/utils/telemetry';

export interface BankLinkingProps {
  title: string;
  subtitle: string;
  buttonVariant?: ButtonVariant;
  textContent: JSX.Element[];
  icon?: JSX.Element;
  step: StepType;
}

export const BankLinkingTile = ({
  title,
  subtitle,
  buttonVariant,
  textContent,
  icon,
  step
}: BankLinkingProps) => {
  const { tStep } = useStepTranslations();

  const {
    bankLinking: { openWidget, accountsConnected, isLoadingWidget: isLoading, disconnectAccount }
  } = useApplication();

  const content = accountsConnected?.length ? (
    <ConnectedAccountsList
      connectedAccounts={accountsConnected}
      disconnectAccount={disconnectAccount}
    />
  ) : (
    textContent
  );

  // Generate telemetery IDs
  const buttonText = accountsConnected?.length
    ? tStep('connect.connectAdditionalAccounts')
    : undefined;

  const buttonId = generateButtonIdForTiles('bank_linking', 'start');

  return (
    <Tile
      title={title}
      subtitle={subtitle}
      button={{
        isLoading,
        isDisabled: isLoading,
        onClick: () => openWidget(),
        variant: buttonVariant,
        children: buttonText,
        telemetryId: buttonId
      }}
      content={content}
      icon={icon}
      telemetryDataAttributes={generateTileDataAttributes(step, 'bank_linking')}
    />
  );
};
